import { NgModule } from '@angular/core';
import {
    provideRouter,
    Routes,
    withComponentInputBinding,
    withRouterConfig,
} from '@angular/router';
import { WINDOW } from '@hs/ui-core-presentation';

import { canAccessNamedQueryGuard } from './guards/can-access-named-query/can-access-named-query.guard';
import { NavWrapperComponent } from './nav-wrapper/nav-wrapper.component';
import { WINDOW_TOKEN } from './services/entitlements.service';

export const routes: Routes = [
    { path: ':clientCode', pathMatch: 'full', redirectTo: ':clientCode/queries' },
    {
        path: ':clientCode',
        component: NavWrapperComponent,
        children: [
            {
                path: 'queries',
                loadChildren: async () => import('./routes').then((m) => m.routes),
                canActivate: [canAccessNamedQueryGuard],
            },
        ],
    },
];

@NgModule({
    providers: [
        { provide: WINDOW_TOKEN, useValue: window },
        { provide: WINDOW, useValue: window },
        provideRouter(
            routes,
            withComponentInputBinding(),
            withRouterConfig({ paramsInheritanceStrategy: 'always' }),
        ),
    ],
})
export class AppRoutingModule {}
